import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getPaises, updatePais, insertPais, deletePais } from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PAISES() {
  try {
    const paisesData = yield call(getPaises)
    if (paisesData.ok) {
      yield put({
        type: actions.PAISES_LOAD_SUCCEEDED,
        payload: paisesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar países')
      put({
        type: actions.PAISES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PAISES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_PAIS(action) {
  try {
    const paisObj = yield call(insertPais, action.payload)
    if (paisObj.ok) {
      putMessage(messageType.SUCCESS, 'País creado correctamente')
      yield put({
        type: actions.PAIS_INSERT_SUCCEEDED,
        payload: paisObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear País')
      yield put({
        type: actions.PAIS_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear País')
    yield all([
      put({
        type: actions.PAIS_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_PAIS(action) {
  try {
    const paisObj = yield call(updatePais, action.payload)
    if (paisObj.ok) {
      putMessage(messageType.SUCCESS, 'País modificado correctamente')
      yield put({
        type: actions.PAIS_UPDATE_SUCCEEDED,
        payload: paisObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar País')
      yield put({
        type: actions.PAIS_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar País')
    yield all([
      put({
        type: actions.PAIS_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_PAIS(action) {
  try {
    const paisResult = yield call(deletePais, action.payload)
    if (paisResult.ok) {
      putMessage(messageType.SUCCESS, 'País eliminado correctamente')
      yield put({
        type: actions.PAIS_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar País')
      yield put({
        type: actions.PAIS_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar País')
    yield all([
      put({
        type: actions.PAIS_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PAISES_LOAD_REQUESTED, GET_PAISES),
    takeEvery(actions.PAIS_INSERT_REQUESTED, INSERT_PAIS),
    takeEvery(actions.PAIS_UPDATE_REQUESTED, UPDATE_PAIS),
    takeEvery(actions.PAIS_DELETE_REQUESTED, DELETE_PAIS),
  ])
}
